import React, { useState } from "react";
import "../Content/CSS/Seatmap.css";

export default function SeatMap({ onDone }) {
  const columns = ["A", "B", "C", "D", "E", "F"];

  const [seatRows] = useState(() =>
    Array.from({ length: 39 }, (_, i) => {
      const rowNum = i + 1;

      return {
        rowNumber: rowNum,
        AirlineSeats: columns.map((letter) => ({
          SeatCode: `${rowNum}${letter}`,
          IsAvailabe: Math.random() > 0.25,
          TotalPrice:
            letter === "A" || letter === "F"
              ? 1299
              : letter === "B" || letter === "E"
              ? 799
              : 449,
        })),
      };
    })
  );

  const [selectedSeats, setSelectedSeats] = useState([]);

  const toggleSeat = (seat) => {
    if (!seat.IsAvailabe) return;

    const exists = selectedSeats.some(
      (s) => s.seatCode === seat.SeatCode
    );

    if (exists) {
      setSelectedSeats((prev) =>
        prev.filter((s) => s.seatCode !== seat.SeatCode)
      );
    } else {
      setSelectedSeats((prev) => [
        ...prev,
        {
          seatCode: seat.SeatCode,
          seatPrice: seat.TotalPrice,
        },
      ]);
    }
  };

  const totalPrice = selectedSeats.reduce(
    (sum, seat) => sum + seat.seatPrice,
    0
  );

  return (
    <div
      className="offcanvas offcanvas-end show"
      tabIndex="-1"
      style={{
        width: "1100px",
        maxWidth: "98vw",
        zIndex: 1070,
      }}
    >
      <div className="offcanvas-header border-bottom">
        <h5>Select Seat</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
        />
      </div>

      <div className="offcanvas-body">

        <div className="seat-container">

          {/* Cockpit */}
          <div className="cockpit-box">
                <img
      src="https://www.tripcaliber.com/Content/Images/flight_cockpit.png"
      alt="Cockpit"
      className="cockpit-img"
    />
            <div className="cockpit-shape">
              <span>COCKPIT</span>
            </div>
          </div>

          {/* Seat Area */}
          <div className="seat-scroll">

            {/* Numbers */}
            <div className="seat-header">
              <div className="seat-letter-space"></div>

              {Array.from({ length: 39 }, (_, i) => (
                <div key={i} className="seat-number">
                  {i + 1}
                </div>
              ))}
            </div>

            {/* F */}
            {["F", "E", "D", "C", "B", "A"].map((letter) => (
              <div className="seat-line" key={letter}>

                <div className="seat-letter">
                  {letter}
                </div>

                {seatRows.map((row) => {
                  const seat = row.AirlineSeats.find(
                    (x) => x.SeatCode.endsWith(letter)
                  );

                  const selected = selectedSeats.some(
                    (s) => s.seatCode === seat.SeatCode
                  );

                  return (
                    <div
                      key={seat.SeatCode}
                      className={`seat-box
                        ${seat.IsAvailabe ? "available" : "occupied"}
                        ${selected ? "selected-seat" : ""}
                      `}
                      title={`${seat.SeatCode} - ₹${seat.TotalPrice}`}
                      onClick={() => toggleSeat(seat)}
                    >
                     <span>{seat.SeatCode}</span>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
  <div className="tail-box">
    <img
      src="https://www.tripcaliber.com/Content/Images/flight_tail.png"
      alt="Tail"
      className="tail-img"
    />
  </div>
        </div>
      </div>

      <div className="offcanvas-bottom p-3 border-top">
        <div className="d-flex justify-content-between align-items-center">

          <div>
            <strong>Selected:</strong>{" "}
            {selectedSeats.length
              ? selectedSeats.map((s) => s.seatCode).join(", ")
              : "None"}
          </div>

          <div className="d-flex align-items-center gap-3">
            <h4 className="mb-0">₹{totalPrice}</h4>

            <button
              className="btn btn-primary px-4"
              onClick={() =>
                onDone(selectedSeats, totalPrice)
              }
            >
              DONE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}